<template>
  <section class="section__contact">
    <!-- Floating case study on right top -->
    <!-- <FloatingCaseStudy :caseColor="caseColor" :caseText="caseText"></FloatingCaseStudy> -->
    <div class="section__contact--bg"></div>
    <div class="section-box flex-row contact-bg">
      <div class="section-box__column">
        <form
          autocomplete="off"
          id="contact-form"
          class="contact-form"
          method="post"
          action="mail.php"
          enctype="multipart/form-data"
        >
          <div class="contact-form__fields">
            <div class="form-group">
              <span class="input input--hoshi">
                <input
                  v-bind:class="this.nameInputState"
                  v-model="inputName"
                  @keyup="triggerName"
                  class="input__field input__field--hoshi"
                  name="name"
                  type="text"
                  id="input-1"
                  autocomplete="off"
                >
                <label
                  class="input__label input__label--hoshi input__label--hoshi-color-1"
                  for="input-1"
                >
                  <span
                    v-bind:class="this.nameInputState"
                    class="input__label-content input__label-content--hoshi"
                  >Your Name</span>
                </label>
              </span>
            </div>
            <div class="form-group">
              <span class="input input--hoshi">
                <input
                  class="input__field input__field--hoshi"
                  type="text"
                  id="input-2"
                  v-model="inputCompany"
                  autocomplete="off"
                >
                <label
                  class="input__label input__label--hoshi input__label--hoshi-color-1"
                  for="input-2"
                >
                  <span class="input__label-content input__label-content--hoshi">Company</span>
                </label>
              </span>
            </div>
            <div class="form-group">
              <span class="input input--hoshi">
                <input
                  v-bind:class="this.emailInputState"
                  v-model="inputEmail"
                  @keyup="triggerEmail"
                  class="input__field input__field--hoshi"
                  type="text"
                  id="input-3"
                  autocomplete="off"
                >
                <label
                  class="input__label input__label--hoshi input__label--hoshi-color-1"
                  for="input-3"
                >
                  <span
                    v-bind:class="this.emailInputState"
                    class="input__label-content input__label-content--hoshi"
                  >Email</span>
                </label>
              </span>
            </div>
            <div class="form-group">
              <multiselect
                v-show="!isMobile"
                v-model="projectType"
                tag-placeholder="Add this as new tag"
                placeholder="Type of project"
                label="name"
                track-by="code"
                :options="options"
                :close-on-select="true"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                id="mulitselect-type"
              ></multiselect>
            </div>
            <div class="form-group">
              <multiselect
                v-model="projectValue"
                :options="options2"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Pick a value"
                id="select-value"
              ></multiselect>
            </div>
            <div class="form-group">
              <span class="input input--hoshi mw-100">
                <textarea
                  class="input__field input__field--hoshi input__textarea mw-100 pt-1"
                  type="textarea"
                  id="input-4"
                  v-model="inputMessage"
                />
                <label
                  v-show="inputMessage.length <= 0"
                  class="input__label input__label--hoshi input__label--hoshi-color-1"
                  for="input-4"
                >
                  <span class="input__label-content input__label-content--hoshi">Message</span>
                </label>
              </span>
            </div>
            <div class="form-group container__checkbox">
              <label class="input__label--checkbox ">
                <input id="checkbox" type="checkbox">
                <span class="checkmark"></span>
              </label>
              <div class="input__label--text">
                <p @click='showRodoInfo = !showRodoInfo'>
                  We would like to inform you about your rights...
                </p>
                <transition name="slide-fade">
                  <p @click='showRodoInfo = !showRodoInfo' v-show='showRodoInfo' id="rodo-content">
                    <span>We would like to inform you about your rights and our obligations. Your data will be collected, processed and used for contact purposes by Agencja Interaktywna InteractiveVision Mariusz Trzeciak.</span>
                    <span>We collect data such as your e-mail address, first name, phone number, IP address, the type of your operating system, and cookies. Your data is safe with us and will not be transferred to any other persons or entities.</span>
                    <span>You can access your data, change them, and request that we erase such data or export them to another system.</span>
                    <span>Do you have any doubts? Contact us for more information: InterVi sp. z o. o. ul. Przemysłowa 14b, 35-105 Rzeszów</span>
                    <span>Very well then. We have a deal, right? :)</span>
                  </p>
                </transition>
                <p class="privacy_policy"><a href="https://ik.imagekit.io/intervi/Intervi-privacy-policy_Hjxxtb_Sy.pdf" target="_blank">Click here</a> to learn more about our Privacy Policy.</p>
              </div>
            </div>
          </div>


          <div class="contact-form__footer d-flex d-lg-block flex-row-reverse justify-content-between align-items-center ml-2 mr-5 mt-3 mt-sm-0 m-lg-0">
            <!-- Error message display -->
            <div class="contact-form__footer--control">
              <transition name="fade_contact" mode="out-in">
                <p class="error" v-if="this.formControl == 'error'" key="error_message">correct the fields</p>
                <p class="success" v-if="this.formControl == 'correct'" key="success_message">message was sent! thank you</p>
              </transition>
            </div>

            <button @click="onSubmit()" type="button" class="btn btn-primary contact-button">
              <svg
                width="23px"
                height="17px"
                viewBox="0 0 23 17"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g
                    id="NEW-NEW-contact"
                    transform="translate(-954.000000, -10372.000000)"
                    fill="#FFFFFF"
                    fill-rule="nonzero"
                  >
                    <g id="Group-31" transform="translate(-106.000000, 4194.000000)">
                      <g id="paper-plane" transform="translate(1060.000000, 6178.000000)">
                        <path
                          d="M22.1081922,0.0108776509 L0.347878764,7.87450347 C-0.0558546507,8.02131562 -0.124672846,8.56268542 0.228593891,8.80125517 L3.4814006,11.0217889 L18.2451975,3.23615708 L5.74781318,12.5679044 L5.74781318,16.3483173 C5.74781318,16.6052386 6.0368496,16.7612265 6.25247995,16.6190022 L9.00520777,14.7930261 L11.7166447,16.6419416 C11.9643902,16.8116931 12.3038933,16.7382871 12.4644691,16.4813658 L22.305471,0.254035275 C22.3880529,0.120986764 22.2550044,-0.0441769055 22.1081922,0.0108776509 Z"
                          id="Shape"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              Send message
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import SectionContactTitle from "@/components/small-components/SectionContactTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import Multiselect from "vue-multiselect";

export default {
  name: "ComponentContact",
  data() {
    return {
      // Initial values of select & multiselect
      projectType: [],
      projectValue: "",
      // Multiselect options
      options: [
        { name: "Typography", code: "typ" },
        { name: "Website", code: "web" },
        { name: "Visual identification", code: "vis" },
        { name: "Social media", code: "soc" }
      ],
      // Singleselect options
      options2: [
        "1000$ - 3000$",
        "3000$ - 7000$",
        "7000$ - 11000$",
        "11000$ - 15000$",
        "15000$ +"
      ],
      // Title component configuration
      title: [
        "Letâ€™s talk",
        "about your",
        '<span class="projectColored">project</span><span class="coloredDot">.</span>'
      ],
      dot: "white",
      textColor: "white",
      // Case study component configuration
      caseText: "Case study.",
      caseColor: "white",
      caseText: "Contact.",
      // Form validation inputs value and state init
      inputName: "",
      nameInputState: "",
      inputCompany: "",
      inputEmail: "",
      emailInputState: "",
      formControl: "",
      inputMessage: "",
      // Rodo
      showRodoInfo: false
    };
  },
  props: {
    showChild: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.hoshi();
  },
  methods: {
    triggerName() {
      this.nameInputState = "correct";
    },
    triggerEmail() {
      this.emailInputState = "correct";
    },

    // Form inputs validation
    checkName() {
      if (
        this.inputName.match(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/) !=
        null
      ) {
        this.nameInputState = "correct";
        return true;
      } else {
        this.nameInputState = "error";
        return false;
      }
    },
    checkEmail() {
      if (
        this.inputEmail.match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        ) != null &&
        this.inputEmail != ""
      ) {
        this.emailInputState = "correct";
        return true;
      } else {
        this.emailInputState = "error";
        return false;
      }
    },
    checkCheckbox() {
      let checkmark = document.querySelector(".checkmark");
      let checkbox = document.getElementById("checkbox");

      checkmark.classList.remove("red-checkmark");
      if (checkbox.checked === false){
        checkmark.classList.add("red-checkmark");
      }
    },

    // Check inputs state, if all inputs true pass to send
    checkForm() {
      this.checkName();
      this.checkEmail();
      // this.checkCheckbox();
      // if (this.emailInputState === "error" || this.nameInputState === "error" || document.getElementById("checkbox").checked === false) {
      if (this.emailInputState === "error" || this.nameInputState === "error") {
        this.formControl = "error";
        return false;
      } else {
        this.formControl = "correct";
        return true;
      }
    },

    clearForm() {
      const input_name = document.getElementById("input-1");
      const input_company = document.getElementById("input-2");
      const input_email = document.getElementById("input-3");
      const input_message = document.getElementById("input-4");
      const form = document.getElementById("contact-form");
      const checkmark = document.querySelector(".checkmark");

      // Find all filled fields and clear haruki input filled class
      let x = document.querySelectorAll(".input--filled");
      for (let i = 0; i < x.length; i++) {
        console.log(x[i]);
        x[i].classList.remove("input--filled");
      }
      // Clear all inputs value
      input_name.value = "";
      input_company.value = "";
      input_email.value = "";
      input_message.value = "";
      // Clear all flags value
      this.inputName = "";
      this.inputCompany = "";
      this.inputEmail = "";
      this.inputMessage = "";
      // Clear multiselect options
      this.projectType = [];
      this.projectValue = "";
      //Clear checkbox border
      // checkmark.classList.remove("red-checkmark");
    },

    // Submit form function
    onSubmit() {
      // Fix scoope
      let _this = this;
      // Check form validation
      this.checkForm();
      if (this.checkForm() == true) {
        console.log("Validation ok");
        fetch("https://intervi-api.herokuapp.com/send", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            name: this.inputName,
            company: this.inputCompany,
            email: this.inputEmail,
            projectType: this.projectType,
            projectValue: this.projectValue,
            message: this.inputMessage
          })
        })
          .then(function(response) {
            return response;
          })
          .then(function(data) {
            // Clear form after send
            _this.clearForm();
          });
      } else {
        console.log("Validation failed");
      }
    },

    // Adding tag in multiselect
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    // Input animation lib + init function
    hoshi() {
      (function(window) {
        "use strict";

        function classReg(className) {
          return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
        }

        // classList support for class management
        // altho to be fair, the api sucks because it won't accept multiple classes at once
        var hasClass, addClass, removeClass;

        if ("classList" in document.documentElement) {
          hasClass = function(elem, c) {
            return elem.classList.contains(c);
          };
          addClass = function(elem, c) {
            elem.classList.add(c);
          };
          removeClass = function(elem, c) {
            elem.classList.remove(c);
          };
        } else {
          hasClass = function(elem, c) {
            return classReg(c).test(elem.className);
          };
          addClass = function(elem, c) {
            if (!hasClass(elem, c)) {
              elem.className = elem.className + " " + c;
            }
          };
          removeClass = function(elem, c) {
            elem.className = elem.className.replace(classReg(c), " ");
          };
        }

        function toggleClass(elem, c) {
          var fn = hasClass(elem, c) ? removeClass : addClass;
          fn(elem, c);
        }

        var classie = {
          // full names
          hasClass: hasClass,
          addClass: addClass,
          removeClass: removeClass,
          toggleClass: toggleClass,
          // short names
          has: hasClass,
          add: addClass,
          remove: removeClass,
          toggle: toggleClass
        };

        // transport
        if (typeof define === "function" && define.amd) {
          // AMD
          define(classie);
        } else {
          // browser global
          window.classie = classie;
        }
      })(window);

      (function() {
        if (!String.prototype.trim) {
          (function() {
            // Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            String.prototype.trim = function() {
              return this.replace(rtrim, "");
            };
          })();
        }

        [].slice
          .call(document.querySelectorAll("input.input__field"))
          .forEach(function(inputEl) {
            // in case the input is already filled..
            if (inputEl.value.trim() !== "") {
              classie.add(inputEl.parentNode, "input--filled");
            }

            // events:
            inputEl.addEventListener("focus", onInputFocus);
            inputEl.addEventListener("blur", onInputBlur);
          });

        function onInputFocus(ev) {
          classie.add(ev.target.parentNode, "input--filled");
        }

        function onInputBlur(ev) {
          if (ev.target.value.trim() === "") {
            classie.remove(ev.target.parentNode, "input--filled");
          }
        }
      })();
    }
  },

  // Init components
  components: {
    SectionContactTitle,
    FloatingSocials,
    Multiselect
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentContact.vue